/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CatalogDto } from '../../models/catalog-dto';

export interface GetCatalog$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;
}

export function getCatalog(http: HttpClient, rootUrl: string, params: GetCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<CatalogDto>> {
  const rb = new RequestBuilder(rootUrl, getCatalog.PATH, 'get');
  if (params) {
    rb.path('svgId', params.svgId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CatalogDto>;
    })
  );
}

getCatalog.PATH = '/svgs/{svgId}/catalog';
